/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import {useEffect, useState, useCallback} from 'react';

import LayoutMain from 'components/Layouts/LayoutMain';
import GaugeChartComponent from 'components/Charts/GaugeChartComponent';
import LinearChart from 'components/Charts/LinearChart';
import MemoryUsed from 'components/MemoryUsed';
import {
	useGetCpuProcessQuery,
	useGetCpuSystemQuery,
	useGetDiameterAppQuery,
	useGetDiskFreeQuery,
	useGetDiskTotalQuery,
	useGetMemoryMaxQuery,
	useGetMemoryUsedQuery,
	useGetSystemConfigPropertyQuery,
	useLazyGetDiameterAppQSQuery,
} from 'services';
import CardMetric from './CardMetric';
import Cards from './Cards';
import type {PerformanceMem, TStateMetrics} from 'types/general';
import {
	defaultValuesMetrics,
	naiveRound,
	calculateMetric,
	formatedTimestamp,
	fillArrayStrings,
	fillArrayNumbers,
	generateDatesArray,
	renderLoop,
	addNumerationToTitles,
} from 'utils';
import {DICTIONARY_DIAMETER} from 'constants/dictionaryDiameter';
import type {IDataChart} from 'interfaces';
import {useAppDispatch} from 'store/hooks';
import {updateState} from 'store/systemConfigProperty';

// constants config
const SECONDS = 1000000000;
// 2 minutes
const LIMIT_ARRAY = 120;

const Dashboard = () => {
	const dispatch = useAppDispatch();

	/* The above code is creating a web worker in a React component. */
	const [intervalWorker, setIntervalWorker] = useState(false);
	useEffect(() => {
		const workerScript = `
			let intervalId;

			self.onmessage = (event) => {
				if (event.data === 'start') {
					intervalId = setInterval(() => {
						self.postMessage('Task completed');
					}, 1000);
				} else if (event.data === 'stop') {
					clearInterval(intervalId);
				}
			};
    `;

		const blob = new Blob([workerScript], {type: 'text/javascript'});
		const workerUrl = URL.createObjectURL(blob);
		const worker = new Worker(workerUrl);

		worker.postMessage('start');

		worker.onmessage = () => {
			setIntervalWorker(prev => !prev);
		};

		return () => {
			worker.postMessage('stop');
			URL.revokeObjectURL(workerUrl);
		};
	}, []);

	const [memPercentage, setMemPercentage] = useState<TStateMetrics>(
		defaultValuesMetrics(),
	);

	const [diskPercentage, setDiskPercentage] = useState<TStateMetrics>(
		defaultValuesMetrics(),
	);

	const [labels, setLabels] = useState<string[]>([
		...generateDatesArray(LIMIT_ARRAY).reverse(),
	]);

	const [processCpu, setProcessCpu] = useState<number[]>([
		...Array(LIMIT_ARRAY).fill(0).reverse(),
	]);
	const [systemCpu, setSystemCpu] = useState<number[]>([
		...Array(LIMIT_ARRAY).fill(0).reverse(),
	]);
	const [memAcumulate, setMemAcumulate] = useState<number[]>([
		...Array(LIMIT_ARRAY).fill(0).reverse(),
	]);
	const [total, setTotal] = useState<number>(24);
	const [totalMemoryUsed, setTotalMemoryUsed] = useState<number>(0);

	const [GxValuesValues, setGxValuesValues] = useState<any>(
		renderLoop(total, LIMIT_ARRAY),
	);

	const [prevResults, setPrevResults] = useState<any>(
		renderLoop(total, 1, false),
	);
	const [results, setResults] = useState<any>(renderLoop(total, 1, false));
	const [totalUnion, setTotalUnion] = useState<[]>([]);

	// API
	// is VolTE or DATA configuration
	const {data: dataSystemConfigProperty} = useGetSystemConfigPropertyQuery(
		undefined,
		{
			refetchOnMountOrArgChange: true,
		},
	);

	// cpu
	const {data: dataProcessCpu} = useGetCpuProcessQuery(undefined, {
		pollingInterval: SECONDS,
		refetchOnMountOrArgChange: false,
		skip: false,
		refetchOnFocus: false,
	});
	const {data: dataSystemCpu} = useGetCpuSystemQuery(undefined, {
		pollingInterval: SECONDS,
		refetchOnMountOrArgChange: false,
		skip: false,
		refetchOnFocus: false,
	});
	// mem
	const {data: dataMemUsed} = useGetMemoryUsedQuery(undefined, {
		pollingInterval: SECONDS,
		refetchOnMountOrArgChange: false,
		skip: false,
		refetchOnFocus: false,
	});
	const {data: dataMemMax} = useGetMemoryMaxQuery(undefined, {
		pollingInterval: SECONDS,
		refetchOnMountOrArgChange: false,
		skip: false,
		refetchOnFocus: false,
	});
	// disk usage
	const {data: dataDiskFree} = useGetDiskFreeQuery(undefined, {
		pollingInterval: SECONDS,
		refetchOnMountOrArgChange: false,
		skip: false,
		refetchOnFocus: false,
	});
	const {data: dataDiskTotal} = useGetDiskTotalQuery(undefined, {
		pollingInterval: SECONDS,
		refetchOnMountOrArgChange: false,
		skip: false,
		refetchOnFocus: false,
	});
	// metrics Gx, Rx, Others
	const {data: diameterData} = useGetDiameterAppQuery();
	const [getDiameterQS] = useLazyGetDiameterAppQSQuery();

	// A callback function that is called when the component is mounted.
	const memoizeMetrics = useCallback(() => {
		if (dataMemUsed && dataMemUsed?.measurements) {
			// Calculating the percentage of memory used.
			setMemPercentage(
				calculateMetric(
					dataMemUsed?.measurements[0].value as never,
					dataMemMax?.measurements[0].value as never,
				),
			);
		}

		if (dataDiskFree && dataDiskFree?.measurements) {
			// Calculating the percentage of disk usage.
			const dataDiskUsed =
				(dataDiskTotal?.measurements[0].value as never) -
				dataDiskFree?.measurements[0].value;
			setDiskPercentage(
				calculateMetric(
					dataDiskUsed as never,
					dataDiskTotal?.measurements[0].value as never,
				),
			);
		}
	}, [dataMemMax, dataMemUsed, dataDiskFree, dataDiskTotal]);

	const handleGetDiameterQS = async (qs: string) => {
		try {
			const result = await getDiameterQS(qs).unwrap();
			return result;
		} catch (error) {
			console.log(error);
		}
	};

	/* A hook that is called when the component is mounted calling memoizeMetrics. */
	useEffect(() => memoizeMetrics(), [intervalWorker]);

	/* This `useEffect` hook is responsible for updating the state variables `prevResults`, `results`, and
	`total` based on the values of `diameterData` and `dataProcessCpu`. */
	useEffect(() => {
		if (diameterData) {
			const arrResults: (number | undefined)[] = [];
			diameterData.forEach(async (qs: string) => {
				const res = await handleGetDiameterQS(qs);
				const before = arrResults?.[arrResults.length - 1] ?? 0;
				const after = res ?? 0; // Ensuring 'after' is not undefined by providing a fallback value
				const difference = after - before;
				if (difference > 0) {
					arrResults.push(difference);
				} else {
					arrResults.push(0);
				}
				setTotal(arrResults.length);
			});
			setPrevResults(results);
			setResults(arrResults);
		}
	}, [intervalWorker]);

	// important useEffect
	useEffect(() => {
		if (dataProcessCpu && dataSystemCpu && dataProcessCpu.measurements) {
			// cpu
			const {measurements} = dataProcessCpu;
			const val = measurements[0].value;
			// system
			const syst = dataSystemCpu ? dataSystemCpu.measurements[0].value : 0;

			// mem
			const {value} = memPercentage;

			setLabels(prev =>
				fillArrayStrings(LIMIT_ARRAY, prev, formatedTimestamp(new Date())),
			);
			setProcessCpu(prev =>
				fillArrayNumbers(LIMIT_ARRAY, prev, naiveRound(val, 2, true)),
			);
			setSystemCpu(prev =>
				fillArrayNumbers(LIMIT_ARRAY, prev, naiveRound(syst, 2, true)),
			);
			setMemAcumulate(prev =>
				fillArrayNumbers(LIMIT_ARRAY, prev, Number((value * 100).toFixed(1))),
			);

			const t = diameterData
				?.map((qs: string, key: number) => {
					const spl = qs.split('_').slice(1);
					const RESPONSE = qs.split('_').slice(0)[4];
					const INIT = qs.split('_').slice(0)[0];

					const operations = DICTIONARY_DIAMETER?.operations[spl[0] as never];

					if (operations) {
						const acronym = operations[spl[1]][spl[2]];
						// const labelMetric = `${spl[1]}_${acronym}${RESPONSE ? '_' + RESPONSE : ''}`;
						const labelMetric = `${INIT}_${acronym}${
							RESPONSE ? '_' + RESPONSE : ''
						}`;

						if (results && results[key]) {
							const {type} = operations[spl[1]];
							return {
								type,
								title: labelMetric,
								value:
									prevResults[key] === 0
										? 0
										: Math.abs(prevResults[key] - results[key]), // always positive number
							};
						}
					}
				})
				.filter((r: IDataChart) => r);

			const arrayTnum = addNumerationToTitles(t);

			setTotal(arrayTnum?.length);

			setGxValuesValues((prev: number[][]) =>
				new Array(total)
					.fill(0)
					?.map((_, idx) =>
						fillArrayNumbers(
							LIMIT_ARRAY,
							(prev && !prev?.[idx]) || prev.length === 0
								? Array(LIMIT_ARRAY).fill(0).reverse()
								: prev?.[idx],
							arrayTnum && !arrayTnum?.[idx] ? 0 : arrayTnum?.[idx]?.value,
						),
					),
			);
			const union = arrayTnum?.map((res: IDataChart, i: number) => ({
				...res,
				values: GxValuesValues[i],
			}));

			setTotalUnion(union as never);

			const {memory} = window.performance as PerformanceMem;

			setTotalMemoryUsed(memory?.usedJSHeapSize as never);
		}
	}, [intervalWorker]);

	// charts
	const dataCPU = [
		{
			title: 'Process',
			values: JSON.parse(JSON.stringify(processCpu)),
		},
		{
			title: 'System',
			values: JSON.parse(JSON.stringify(systemCpu)),
		},
	];

	const dataMem = [
		{
			title: 'Process',
			values: JSON.parse(JSON.stringify(memAcumulate)),
		},
	];

	/* The `useEffect` hook is used to update the state of the `dataSystemConfigProperty` variable. It
	listens for changes in the `dataSystemConfigProperty` variable and triggers the callback function
	whenever there is a change. */
	useEffect(() => {
		if (dataSystemConfigProperty) {
			dispatch(updateState(dataSystemConfigProperty?.value));
		}
	}, [dataSystemConfigProperty]);

	return (
		<LayoutMain>
			<div id="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-12">
							<h1 className="mt-2">PCRF/PCF</h1>
						</div>
					</div>

					<Cards />

					<CardMetric title="Gauges" subtitle="Metrics">
						<div className="card-body">
							<div className="row mt-4">
								<div className="col-xl-4 col-md-6 mb-4">
									<GaugeChartComponent
										id="cpu"
										percent={
											dataProcessCpu && dataProcessCpu?.measurements
												? naiveRound(
														dataProcessCpu?.measurements[0].value as never,
														2,
												  )
												: 0
										}
										description="CPU"
									/>
								</div>

								<div className="col-xl-4 col-md-6 mb-4">
									<GaugeChartComponent
										id="mem"
										percent={memPercentage.value}
										description={`MEM ${memPercentage.used.value} ${memPercentage.used.type} / ${memPercentage.max.value} ${memPercentage.max.type}`}
									/>
								</div>

								<div className="col-xl-4 col-md-6 mb-4">
									<GaugeChartComponent
										id="disk"
										percent={diskPercentage.value}
										description={`Disk Usage ${diskPercentage.used.value} ${diskPercentage.used.type} / ${diskPercentage.max.value} ${diskPercentage.max.type}`}
									/>
								</div>
							</div>
						</div>
					</CardMetric>

					<CardMetric title="History" subtitle="Metrics">
						<div className="card-body">
							<div className="row mt-4">
								<div className="col-xl-6 mb-4">
									<LinearChart
										id="cpu"
										labels={labels}
										data={dataCPU}
										titleCard="CPU %"
									/>
								</div>

								<div className="col-xl-6 mb-4">
									<LinearChart
										id="cpu"
										labels={labels}
										data={dataMem}
										titleCard="MEM %"
									/>
								</div>
							</div>
						</div>
					</CardMetric>

					<CardMetric title="History" subtitle="Metrics">
						<div className="card-body">
							<div className="row mt-4">
								<div className="col-xl-4 mb-4">
									<LinearChart
										id="gx"
										labels={labels}
										data={totalUnion?.filter(({type}) => type === 'Gx')}
										titleCard="Gx IO/s"
										animation={false}
									/>
								</div>

								<div className="col-xl-4 mb-4">
									<LinearChart
										id="rx"
										labels={labels}
										data={totalUnion?.filter(({type}) => type === 'Rx')}
										titleCard="Rx IO/s"
										animation={false}
									/>
								</div>

								<div className="col-xl-4 mb-4">
									<LinearChart
										id="others"
										labels={labels}
										data={totalUnion?.filter(({type}) => type === 'Others')}
										titleCard="Others"
										animation={false}
									/>
								</div>
							</div>
						</div>
					</CardMetric>

					<MemoryUsed totalMemoryUsed={totalMemoryUsed} />
				</div>
			</div>
		</LayoutMain>
	);
};

export default Dashboard;
